// extracted by mini-css-extract-plugin
export default {"main_div":"Home_main_div__Zggnc","graph_div":"Home_graph_div__KePJv"};